// extracted by mini-css-extract-plugin
export default {"section":"social-suggested-followees-FollowSection__section--UGB04"};